import { forwardRef } from "react"

import Input from "@molecules/Form/inputs/Input/Input"
import { InputProps } from "@molecules/Form/inputs/Input/Input.types"

function EmailInput<T>(props: InputProps<T>, ref: React.Ref<HTMLInputElement>) {
    const { ...rest } = props

    return <Input ref={ref} type="email" {...rest} />
}

interface EmailInputComponent {
    <T>(props: InputProps<T> & React.RefAttributes<HTMLInputElement>): React.ReactElement | null
    displayName?: string
}

const EmailInputWithRef = forwardRef(EmailInput) as unknown as EmailInputComponent
EmailInputWithRef.displayName = "Input"

export default EmailInputWithRef
